import dayjs from "dayjs";
import { array, date, object, string } from "yup";

export const VALIDATION_SCHEMA = object().shape({
  transactionDate: date().required("Harus diisi"),
  // Required by the API since it declares seller_bank_account_id as
  // @IsNotEmpty with an existence check.
  sellerBankAccount: object().nullable().required("Harus diisi"),
  note: string().nullable(),
  // One entry per expense line on the source invoice. Accounts only — the
  // amount is read from the sales invoice by the backend, never sent.
  expenseAccounts: array().of(
    object().shape({
      salesInvoiceExpenseId: string().required(),
      outletChartOfAccount: object().nullable().required("Harus diisi"),
    })
  ),
});

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  sellerBankAccount: null,
  note: "",
  expenseAccounts: [],
};
